// useViewModalViewTypes.js

import { useCallback, useEffect, useMemo } from 'react';

import {
  buildViewOptions,
  resolveViewTypeOptionKey,
  resolveViewTypeSelection,
} from '../viewModalViewTypes';

// Centralizes view type options and keeps the active type valid.
const useViewModalViewTypes = ({
  type,
  applyTypeSelection,
  preset = 'timeline',
  hasEnumFields,
}) => {
  const viewOptions = useMemo(
    () => buildViewOptions(hasEnumFields),
    [hasEnumFields]
  );

  const selectedOptionKey = useMemo(
    () => resolveViewTypeOptionKey(type, preset),
    [preset, type]
  );

  const handleSelectViewType = useCallback((nextValue) => {
    const matchedOption = viewOptions.find((option) => {
      const optionKey = String(option?.optionKey || option?.value || option?.key || '').trim();
      return optionKey === String(nextValue || '').trim();
    }) || null;

    const selection = resolveViewTypeSelection(matchedOption || nextValue);
    if (typeof applyTypeSelection === 'function') {
      applyTypeSelection(selection);
      return;
    }
  }, [applyTypeSelection, viewOptions]);

  useEffect(() => {
    if (!hasEnumFields && type === 'BOARD') {
      handleSelectViewType('LIST');
    }
  }, [handleSelectViewType, hasEnumFields, type]);

  return {
    handleSelectViewType,
    selectedOptionKey,
    viewOptions,
  };
};

export default useViewModalViewTypes;
